<template>
    <main>
        <div class="box">
            <div class="mark" @click="hideWait"></div>
            <div class="content" v-scroll-lock="true">
                <div class="close" @click="hideWait"></div>
                <div class="middle">
                    <div class="title">您好，欢迎参加2023 戴尔科技峰会</div>
                    <div class="m-title">尚未开启，敬请期待！</div>
                    <div class="btn-box">
                        <div class="btn" @click="hideWait">确认</div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'wait',
        data() {
            return {}
        },
        components:{

        },
        computed:{

        },
        methods: {
            hideWait(){
                this.util.showWait(false);
            }
        },
        mounted() {
            this.query = this.$route.query;
        },
        destroyed() {
            this.hideWait();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .box{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 100;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8)}
        .content{position: absolute;left:50%;top:50%;width:6.9rem;height:4rem;background: url("~@/assets/image/2025/bg-success.png") no-repeat center center;background-size: cover;color: #232846;transform: translate(-50%,-50%); border-radius: .1rem;
            .close{width: .5rem;height:.5rem;position: absolute;top:0;right:0;background: url("~@/assets/image/54.png") no-repeat center center;background-size:.25rem;cursor: pointer;transition: background .3s ease;}
            .middle{width:6.9rem;height:4.4rem;text-align: center;
                .title{font-size: .26rem;}
                .m-title{font-size:.4rem;margin-top: .2rem;}
                .btn-box{margin-top:.4rem;
                    .btn{width: 2rem;height:.66rem;text-align: center;line-height: .66rem;color:#fff;background: #ec6014;margin: .3rem auto 0;border-radius: .1rem;}
                }
            }
        }
    }
</style>

